<template>
  <div>
    <span class="caption blue-grey--text text--darken-1">
      {{ title }}
    </span>
    <v-card class="card-border my-2" outlined>
      <div class="d-flex px-3 py-4">
        <UserAvatar size="32px" fontSize="10" :account="account" />

        <div class="ms-2 overflow-hidden">
          <p class="subtitle2 blue-grey--text text--darken-2 mb-1 ellipsis">
            {{ userFullName }}
          </p>
          <p class="subtitle2 blue-grey--text text--darken-1 mb-0 ellipsis">
            {{ account.email }}
          </p>
        </div>
      </div>

      <div class="d-flex flex-column pa-3 w-100">
        <Button
          color="primaryLighten"
          size="small"
          :text="
            $t('home.activity_board.incomplete_profile.complete_profile_button')
          "
          @click="redirectUser"
        />
      </div>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import userMixin from '@/mixins/userMixin.vue'
import mixin from '@/mixins/mixin.vue'

import UserAvatar from '@/components/UserAvatar.vue'
import Button from '@/components/UI/Button.vue'

export default {
  name: 'IncompleteProfile',

  mixins: [userMixin, mixin],

  components: {
    Button,
    UserAvatar,
  },

  computed: {
    ...mapGetters(['account', 'organizationId']),

    title() {
      if (!this.account.photo)
        return this.$t('home.activity_board.incomplete_profile.no_photo_title')
      if (!this.account.position)
        return this.$t(
          'home.activity_board.incomplete_profile.no_job_position_title'
        )
      return ''
    },

    userFullName() {
      return this.getFullName(this.account)
    },
  },

  methods: {
    redirectUser() {
      const route = !this.account.photo
        ? {
            name: 'profile',
            params: {
              organizationId: this.organizationId,
              userId: this.account._id,
            },
          }
        : { name: 'profileSettings' }

      this.navigateTo(route)
    },
  },
}
</script>

<style scoped>
.ellipsis {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
